<script>
/**
 * Nav-bar Component
 */
export default {
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<template>
  <b-card no-body>
    <b-row no-gutters class="align-items-center">
      <b-col md="4">
        <b-card-img :src="require('@/assets/images/logo-dark.svg')" class="rounded-0"></b-card-img>
      </b-col>
      <b-col md="8">
        <b-card-body>
          <div>
            <b-card-text class="mb-0" v-if="resource.businesses"><strong>{{ $t('client_file.businesses') }} : </strong>
              <template v-for="(model, index) in resource.businesses">
                <template v-if="index > 0">,&nbsp;</template>
                <span :key="model.id">{{ model.name }}</span>
              </template>
            </b-card-text>
            <b-card-text v-if="resource.location" class="mb-0"><strong>{{ $t('client_file.location') }} : </strong>
              {{ resource.location.name }}
            </b-card-text>
            <b-card-text class="mb-0" v-if="resource.numerisations"><strong>{{ $t('client_file.numerisations') }}
              : </strong>
              <template v-for="(model, index) in resource.numerisations">
                <template v-if="index > 0">,&nbsp;</template>
                <span :key="model.id">{{ model.name }}</span>
              </template>
            </b-card-text>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>
